import React from "react";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";

const Unauthorized = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const user = auth.currentUser;

  const handleGoToDashboard = () => {
    if (user) {
      navigate("/dashboard"); // Redirect logged-in users
    } else {
      navigate("/login"); // Redirect unauthenticated users to login
    }
  };

  const handleGoBack = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div style={styles.container}>
      <h1>Unauthorized Access</h1>
      <p>You do not have permission to view this page.</p>
      <button
        onClick={handleGoToDashboard}
        style={{
          padding: "10px 20px",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Go to Dashboard
      </button>
      <button onClick={handleGoBack} style={styles.button}>
        Go Back
      </button>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "20px",
    backgroundColor: "#f8d7da",
    minHeight: "100vh",
  },
  button: {
    backgroundColor: "#dc3545",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default Unauthorized;
